import {DatePipe} from '@angular/common';
import {Component, inject, input, InputSignal, output, OutputEmitterRef} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ServiceCase} from '../../../../core/service-case/models/service-case';
import {UserService} from '../../../../core/user/services/user.service';
import {OrderAndAppointmentSearchResult} from '../../../dms-search/order-and-appointment-search-result';

@Component({
  selector: 'app-dms-order-for-vin-selection',
  templateUrl: './dms-order-for-vin-selection.component.html',
  styleUrls: ['./shared-styles.scss'],
  imports: [DatePipe, TranslateModule]
})
export class DmsOrderForVinSelectionComponent {
  private readonly userService: UserService = inject(UserService);

  readonly newCaseWithOrder: OutputEmitterRef<ServiceCase> = output<ServiceCase>();

  readonly orderList: InputSignal<OrderAndAppointmentSearchResult[]> = input<OrderAndAppointmentSearchResult[]>();

  visible: boolean = false;
  locale: string;

  constructor() {
    this.locale = this.userService.getCurrentUser()?.getLocale();
    this.userService.user$.subscribe(user => {
      this.locale = user.getLocale();
    });
  }

  orderSelected(dcomOrderOrAppointment: OrderAndAppointmentSearchResult): void {
    this.visible = false;
    const newServiceCaseWithDmsData: ServiceCase = ServiceCase.constructMinimalServiceCase(this.userService.getCurrentUser());
    if (dcomOrderOrAppointment.vehicle.vin?.length === 7) {
      newServiceCaseWithDmsData.setVinShort(dcomOrderOrAppointment.vehicle.vin);
    } else {
      newServiceCaseWithDmsData.setVinLong(dcomOrderOrAppointment.vehicle.vin);
    }
    newServiceCaseWithDmsData.setLicensePlate(dcomOrderOrAppointment.vehicle.numberPlate);
    newServiceCaseWithDmsData.setDmsOrderNumber(dcomOrderOrAppointment.dmsId);
    newServiceCaseWithDmsData.setDmsCustomerNumber(dcomOrderOrAppointment.customer?.customerId?.dmsId);
    newServiceCaseWithDmsData.updateCustomerName(dcomOrderOrAppointment.customer);
    newServiceCaseWithDmsData.setIsDmsPreOrder(dcomOrderOrAppointment.isDmsPreOrder);
    this.newCaseWithOrder.emit(newServiceCaseWithDmsData);
  }
}
